import * as actionTypes from 'constants/ActionTypes';

// export function postRequestTC(tcRequest, index) {
//     return {
//         type: actionTypes.POST_TC_REQUEST.REQUEST,
//         tcRequest,
//         index
//     };
// }

export function getTcHireIdeas(filter) {
    return {
        type: actionTypes.GET_TC_INDEXES.REQUEST,
        filter,
    };
}

// export function deleteRequestTC(tcRequestId) {
//     return {
//         type: actionTypes.DELETE_TC_REQUEST.REQUEST,
//         tcRequestId,
//     };
// }


// WEBPACK FOOTER //
// ./app/actions/tc/indexes.js